<style>
.wrapper {
  @apply w-full;
}
.inputs-wrapper {
  @apply grid grid-cols-3 gap-4;
}
.error {
  @apply px-4 mt-1 text-xs leading-none;
  color: #c4272a;
}
</style>

<script>
import Select from "./_Select.svelte"
import SubHeading from "./SubHeading.svelte"

export let name = ""
export let label = ""
export let value = undefined
export let className = ""
export let startYear = new Date().getFullYear()
export let sortYear = "desc"
export let qtyYear = 110

let [year, month, day] = value ? value.split("T")[0].split("-") : ["", "", ""]

const monthOptions = buildOptions(1, 12, "asc")
const yearOptions = buildOptions(startYear, qtyYear, sortYear)
const dayOptions = buildOptions(1, 31, "asc")

let _errors
export { _errors as errors }
$: errors = _errors || []
$: hasErrors = errors.length > 0
$: updateValue(year, month, day)

function updateValue(year, month, day) {
  if (year && month && day) {
    const dd = `${day}`.padStart(2, "0")
    const mm = `${month}`.padStart(2, "0")
    value = `${year}-${mm}-${dd}`
  } else {
    value = undefined
  }
}

function buildOptions(startOption, qtyOption, sort) {
  return new Array(qtyOption)
    .fill(0)
    .map((_, i) => (sort === "asc" ? startOption + i : startOption - i))
    .map((x) => `${x}`.padStart(2, "0"))
}
</script>

<div class="wrapper {className}" id="{name}">
  <SubHeading className="mb-8" content="{label}" />
  <div class="inputs-wrapper">
    <Select
      label="{'mm'}"
      options="{monthOptions}"
      bind:value="{month}"
      hasErrors="{hasErrors}"
      includeEmpty="{true}"
    />
    <Select
      label="{'dd'}"
      options="{dayOptions}"
      bind:value="{day}"
      hasErrors="{hasErrors}"
      includeEmpty="{true}"
    />
    <Select
      label="{'yyyy'}"
      options="{yearOptions}"
      bind:value="{year}"
      hasErrors="{hasErrors}"
      includeEmpty="{true}"
    />
  </div>
  {#if hasErrors}
    <div class="error">{errors[0]}</div>
  {/if}
</div>
